export interface CourseCreationRequisitesUser {
  inn?: string;
  registration_number?: string;
  certificate_serial_number?: string;
  certificate_owner_full_name?: string;
  certificate_valid_from?: string | null;
  certificate_valid_to?: string | null;
}

export const hasRequiredCourseCreationRequisites = (
  user: CourseCreationRequisitesUser,
): boolean => {
  const inn = (user.inn || "").trim();
  const registrationNumber = (user.registration_number || "").trim();

  return Boolean(
    [10, 12].includes(inn.length) &&
      /^\d+$/.test(inn) &&
      [13, 15].includes(registrationNumber.length) &&
      /^\d+$/.test(registrationNumber) &&
      (user.certificate_serial_number || "").trim() &&
      (user.certificate_owner_full_name || "").trim() &&
      user.certificate_valid_from &&
      user.certificate_valid_to
  );
};
